import isEmpty from 'lodash.isempty';
import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';

export const sortAttributes = (
    attributes: AttributeDetailInfo[],
): AttributeDetailInfo[] => {
    return attributes.toSorted((a, b) => {
        if (a.deprecated === b.deprecated) {
            return isEmpty(a.possibleValues) ? 1 : -1;
        }

        return a.deprecated ? 1 : -1;
    });
};
